/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const de_bookmark__iti_deleted__success = /** @type {(inputs: {}) => string} */ () => {
	return `Route aus Ihren Favoriten entfernt`
};

const en_bookmark__iti_deleted__success = /** @type {(inputs: {}) => string} */ () => {
	return `Route removed from your favourites`
};

const es_bookmark__iti_deleted__success = /** @type {(inputs: {}) => string} */ () => {
	return `Itinerario eliminada de favoritos`
};

const fr_bookmark__iti_deleted__success = /** @type {(inputs: {}) => string} */ () => {
	return `Itinéraire supprimé des favoris`
};

const it_bookmark__iti_deleted__success = /** @type {(inputs: {}) => string} */ () => {
	return `Itinerario rimosso dai preferiti`
};

const nl_bookmark__iti_deleted__success = /** @type {(inputs: {}) => string} */ () => {
	return `Route verwijderd uit je favorieten`
};

const pt_bookmark__iti_deleted__success = /** @type {(inputs: {}) => string} */ () => {
	return `Itinerário removida dos favoritos`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const bookmark__iti_deleted__success = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.bookmark__iti_deleted__success(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("bookmark__iti_deleted__success", locale)
	if (locale === "de") return de_bookmark__iti_deleted__success(inputs)
	if (locale === "en") return en_bookmark__iti_deleted__success(inputs)
	if (locale === "es") return es_bookmark__iti_deleted__success(inputs)
	if (locale === "fr") return fr_bookmark__iti_deleted__success(inputs)
	if (locale === "it") return it_bookmark__iti_deleted__success(inputs)
	if (locale === "nl") return nl_bookmark__iti_deleted__success(inputs)
	return pt_bookmark__iti_deleted__success(inputs)
};